/**
 * Utility functions for extracting and formatting tips and gratuity details
 * from order objects (Course-wise tips, Split tips, Direct tips).
 */

export const getOrderTipsDetails = (order) => {
  if (!order) {
    return {
      hasTips: false,
      totalTips: 0,
      tipsMode: null, // "course_wise" | "split" | "direct" | null
      breakdown: [],  // Array of { payerName, tipType, tipInputAmount, tipAmount, source }
    };
  }

  // 1. Check tips_breakdown array
  const rawBreakdown = Array.isArray(order?.tips_breakdown) ? order.tips_breakdown : [];
  const breakdown = rawBreakdown.map((item, index) => ({
    payerName: item?.payer_name || `Person ${index + 1}`,
    tipType: item?.tip_type || "fixed",
    tipInputAmount: Number(item?.tip_input_amount || item?.tip_amount || 0),
    tipAmount: Number(item?.tip_amount || 0),
    source: item?.source || order?.tips_mode || "course_wise",
  }));

  // 2. Resolve total tips amount
  const breakdownSum = breakdown.reduce((sum, item) => sum + (item.tipAmount || 0), 0);

  let totalTips = 0;
  if (order?.total_tips_amount !== undefined && order?.total_tips_amount !== null && Number(order.total_tips_amount) > 0) {
    totalTips = Number(order.total_tips_amount);
  } else if (order?.distributed_tips_amount !== undefined && order?.distributed_tips_amount !== null && Number(order.distributed_tips_amount) > 0) {
    totalTips = Number(order.distributed_tips_amount);
  } else if (breakdownSum > 0) {
    totalTips = breakdownSum;
  } else if (order?.tips_amount !== undefined && order?.tips_amount !== null && Number(order.tips_amount) > 0) {
    totalTips = Number(order.tips_amount);
  } else if (order?.payment?.tips_amount !== undefined && order?.payment?.tips_amount !== null && Number(order.payment.tips_amount) > 0) {
    totalTips = Number(order.payment.tips_amount);
  } else if (order?.payment?.tips !== undefined && order?.payment?.tips !== null && Number(order.payment.tips) > 0) {
    totalTips = Number(order.payment.tips);
  } else if (order?.tip_type === "fixed" && order?.tips !== undefined && order?.tips !== null && Number(order.tips) > 0) {
    totalTips = Number(order.tips);
  } else if (order?.total_tips_amount !== undefined && order?.total_tips_amount !== null) {
    totalTips = Number(order.total_tips_amount);
  } else if (order?.tips_amount !== undefined && order?.tips_amount !== null) {
    totalTips = Number(order.tips_amount);
  } else {
    totalTips = 0;
  }

  const tipsMode =
    order?.tips_mode ||
    (breakdown.length > 0 ? breakdown[0]?.source : null) ||
    (totalTips > 0 ? "direct" : null);

  return {
    hasTips: totalTips > 0,
    totalTips: Number(totalTips.toFixed(2)),
    tipsMode,
    breakdown,
  };
};

export default getOrderTipsDetails;
